namespace $.$$ {
	$.$shm_hitalama_compat_fqn_install( $ as any )

	export class $shm_codex_app extends $.$shm_codex_app {

		app_pages() {
			this.events().native()
			this.session_bring_ensure()
			return [ this.Chat_page() ]
		}

		chat_body() {
			return this.session_id() ? [ this.Messages_box() ] : [ this.No_session() ]
		}

		@ $mol_mem
		session_brought( next?: string ) {
			return next ?? ''
		}

		@ $mol_action
		session_bring_ensure() {
			const id = this.session_id()
			if( !id || this.session_brought() === id ) return null
			this.session_brought( id )
			new this.$.$mol_after_tick( ()=> {
				if( this.session_id() === id ) this.session_bring()
			} )
			return null
		}

		session_bring() {
			new this.$.$mol_after_tick( ()=> {
				const book = this.dom_node() as HTMLElement
				const page = this.Chat_page().dom_node() as HTMLElement
				book.scroll({
					left: page.offsetLeft + page.offsetWidth - book.offsetWidth,
					behavior: 'smooth',
				})
			} )
		}

		@ $mol_mem
		override session_id( next?: string ) {
			return this.$.$mol_state_arg.value( 'session', next === undefined ? undefined : next || null ) ?? ''
		}

		@ $mol_mem
		thread_refresh( next?: number ) {
			return next ?? 0
		}

		@ $mol_mem
		goal_refresh( next?: number ) {
			return next ?? 0
		}

		@ $mol_mem
		busy_local( next?: boolean ) {
			return next ?? false
		}

		@ $mol_mem
		events() {
			return this.$.$shm_codex_api_events.make({
				url: ()=> this.server_url(),
				notify: $mol_const( event => this.event_handle( event ) ),
			})
		}

		@ $mol_action
		event_handle( event: any ) {
			const thread = event.params?.threadId || event.params?.thread?.id
			if( event.method === 'thread/started' && event.params?.thread ) this.session_upsert( event.params.thread )
			if( event.method === 'thread/name/updated' && thread ) {
				const session = this.session_by_id( thread )
				if( session ) this.session_upsert({ ... session, name: event.params.name })
			}
			if( ( event.method === 'thread/archived' || event.method === 'thread/deleted' ) && thread ) this.session_remove( thread )
			if( event.method?.startsWith( 'thread/goal/' ) ) this.goal_refresh( this.goal_refresh() + 1 )
			if( thread !== this.session_id() ) return
			if( event.method === 'turn/started' ) this.busy_local( true )
			if( event.method === 'item/completed' || event.method === 'turn/completed' ) {
				this.thread_refresh( this.thread_refresh() + 1 )
				new this.$.$mol_after_frame( ()=> this.messages_to_bottom() )
			}
			if( event.method === 'turn/completed' ) this.busy_local( false )
		}

		@ $mol_mem
		sessions_data( next?: $shm_codex_api_thread[] ) {
			if( next !== undefined ) return next
			return $mol_wire_sync( $shm_codex_api ).sessions( this.server_url() ).data
		}

		session_upsert( session: $shm_codex_api_thread ) {
			const sessions = this.sessions_data()
			const current = sessions.findIndex( item => item.id === session.id )
			if( current === -1 ) return this.sessions_data( [ session, ... sessions ] )
			const next = [ ... sessions ]
			next[ current ] = { ... next[ current ], ... session }
			return this.sessions_data( next )
		}

		session_remove( id: string ) {
			return this.sessions_data( this.sessions_data().filter( session => session.id !== id ) )
		}

		session_rows() {
			const query = this.search_query().trim().toLowerCase()
			return this.sessions_data()
				.filter( session => !query || this.session_title( session.id ).toLowerCase().includes( query ) )
				.map( session => this.Session( session.id ) )
		}

		session_by_id( id: string ) {
			return this.sessions_data().find( session => session.id === id )
		}

		session_title( id: string ) {
			const session = this.session_by_id( id )
			return session?.name || session?.preview || `Сессия ${ id.slice( 0, 8 ) }`
		}

		session_current_title() {
			const id = this.session_id()
			return id ? this.session_title( id ) : 'Выбрать сессию'
		}

		session_current( id: string ) {
			return id === this.session_id()
		}

		override session_select( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.session_id( id )
			this.busy_local( false )
			this.session_bring()
			return next
		}

		override create( next?: Event ) {
			if( next === undefined ) return null
			$mol_wire_async( this ).create_later().catch( $mol_fail_log )
			return next
		}

		create_later() {
			const title = this.new_session_title().trim() || 'Новая сессия'
			this.session_create_later( title )
		}

		session_create_name( title: string ) {
			return title
		}

		session_create_instructions() {
			return ''
		}

		session_first_title( text: string ) {
			const compact = text.replace( /\s+/g, ' ' ).trim()
			return compact.length > 64 ? `${ compact.slice( 0, 61 ) }...` : compact || 'Новая сессия'
		}

		session_create_later( title: string ) {
			const result = $mol_wire_sync( $shm_codex_api ).create_session(
				this.server_url(),
				this.session_create_name( title ),
				'',
				this.session_create_instructions(),
			)
			this.new_session_title( '' )
			this.session_id( result.thread.id )
			this.session_upsert( result.thread )
			this.session_bring()
			return result.thread.id
		}

		thread_data() {
			const id = this.session_id()
			if( !id ) return null
			return $mol_wire_sync( $shm_codex_api ).thread( this.server_url(), id, this.thread_refresh() )
		}

		chat_title() {
			return `Чат (${ this.message_items().length })`
		}

		chat_provider() {
			return this.thread_data()?.thread.modelProvider || 'Codex'
		}

		chat_status() {
			return this.busy() ? 'Выполняется' : 'Готов'
		}

		message_items() {
			return ( this.thread_data()?.thread.turns ?? [] ).flatMap( turn => turn.items.map( item => ({
				... item,
				id: `${ turn.id }:${ item.id }`,
				turnStartedAt: turn.startedAt,
			}) ) )
				.filter( item => [ 'userMessage', 'agentMessage' ].includes( item.type ) )
		}

		message_rows() {
			return this.message_items().map( item => this.Message( item.id ) )
		}

		message_by_id( id: string ) {
			return this.message_items().find( item => item.id === id )
		}

		message_role_key( id: string ) {
			return this.message_by_id( id )?.type ?? ''
		}

		message_role( id: string ) {
			return this.message_role_key( id ) === 'userMessage' ? 'Вы' : 'Codex'
		}

		message_theme( id: string ) {
			return this.message_role_key( id ) === 'agentMessage' ? '$mol_theme_special' : ''
		}

		message_time( id: string ) {
			const time = ( this.message_by_id( id ) as any )?.turnStartedAt
			return time ? new Date( time * 1000 ).toLocaleString() : ''
		}

		message_text( id: string ) {
			const item = this.message_by_id( id )
			if( !item ) return ''
			if( item.type === 'userMessage' ) return item.content?.map( part => part.text || '' ).join( '\n' ) ?? ''
			if( item.type === 'agentMessage' ) return item.text ?? ''
			return ''
		}

		messages_to_bottom() {
			const node = this.Messages().dom_node()
			node.scrollTop = node.scrollHeight
		}

		goal_data() {
			const id = this.session_id()
			if( !id ) return null
			return $mol_wire_sync( $shm_codex_api ).goal( this.server_url(), id, this.goal_refresh() ).goal
		}

		@ $mol_mem_key
		goal_draft( id: string, next?: string ) {
			return next ?? this.goal_data()?.objective ?? ''
		}

		override goal_text( next?: string ) {
			return this.goal_draft( this.session_id(), next )
		}

		goal_status() {
			const goal = this.goal_data()
			if( !goal ) return 'Не задана'
			return `${ goal.status } · ${ goal.tokensUsed } токенов · ${ Math.round( goal.timeUsedSeconds ) } с`
		}

		override goal_set( next?: Event ) {
			if( next === undefined ) return null
			const objective = this.goal_text().trim()
			if( !objective ) return next
			$mol_wire_async( this ).goal_set_later( objective ).catch( $mol_fail_log )
			return next
		}

		goal_set_later( objective: string ) {
			$mol_wire_sync( $shm_codex_api ).goal_set( this.server_url(), this.session_id(), objective )
			this.goal_refresh( this.goal_refresh() + 1 )
		}

		override goal_clear( next?: Event ) {
			if( next === undefined ) return null
			$mol_wire_async( this ).goal_clear_later().catch( $mol_fail_log )
			return next
		}

		goal_clear_later() {
			const id = this.session_id()
			$mol_wire_sync( $shm_codex_api ).goal_clear( this.server_url(), id )
			this.goal_draft( id, '' )
			this.busy_local( false )
			this.thread_refresh( this.thread_refresh() + 1 )
			this.goal_refresh( this.goal_refresh() + 1 )
		}

		busy() {
			return this.busy_local() || Boolean( this.thread_data()?.activeTurnId )
		}

		send_hint() {
			return this.busy() ? 'Остановить' : 'Отправить'
		}

		send_content() {
			return [ this.busy() ? this.Stop_icon() : this.Send_icon() ]
		}

		override send( next?: Event ) {
			if( next === undefined ) return null
			if( this.busy() ) {
				$mol_wire_async( this ).stop_later().catch( $mol_fail_log )
				return next
			}
			const text = this.prompt().trim()
			if( !text ) return next
			this.busy_local( true )
			$mol_wire_async( this ).send_later( text ).catch( error => {
				this.busy_local( false )
				$mol_fail_log( error )
			} )
			return next
		}

		send_later( text: string ) {
			const id = this.session_id() || this.session_create_later( this.session_first_title( text ) )
			$mol_wire_sync( $shm_codex_api ).send( this.server_url(), id, text )
			if( this.prompt().trim() === text ) this.prompt( '' )
			this.thread_refresh( this.thread_refresh() + 1 )
		}

		stop_later() {
			$mol_wire_sync( $shm_codex_api ).stop( this.server_url(), this.session_id() )
			this.busy_local( false )
			this.thread_refresh( this.thread_refresh() + 1 )
		}

	}

}
